module.exports = __webpack_public_path__ + "static/media/information_Partner_2.0.43141c7f.pdf";